import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=13b20502"
import script from "./billDetails.vue?vue&type=script&lang=js"
export * from "./billDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports